import Sidebar from "../components/Sidebar";

export default function GpDashboard() {
  return (
    <div className="dashboard-container">
      <Sidebar />
      <div className="dashboard-content">
        <h1>GP Coordinator Dashboard</h1>
        <p>Welcome GP Coordinator</p>
      </div>
    </div>
  );
}